import React, { useEffect, useState } from 'react';
import { Package } from 'lucide-react';
import { proxyImg } from '../../services/api';
import './ProductThumb.css';

/**
 * ProductThumb — фото товара с заглушкой: нет ссылки или картинка не
 * загрузилась — аккуратный квадрат с иконкой коробки вместо значка битой
 * картинки (аудит U12).
 *
 *   src     — ссылка на фото (внешние идут через /api/products/image-proxy)
 *   size    — сторона в px (по умолчанию 40)
 *   alt     — подпись (артикул/название) для скринридера
 *   proxy   — пропускать через прокси (по умолчанию да; false — ссылка как есть)
 *   hideIfEmpty — без фото не занимать место (в плотных списках)
 *   rounded — 'sm' | 'md' (по умолчанию md)
 */
export function ProductThumb({ src, size = 40, alt = '', proxy = true, hideIfEmpty = false, rounded = 'md', className = '', title, onClick }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);

  const empty = !src || broken;
  if (empty && hideIfEmpty) return null;
  const style = { width: size, height: size };
  const cls = `ui-thumb ui-thumb--r-${rounded} ${empty ? 'ui-thumb--empty' : ''} ${onClick ? 'ui-thumb--clickable' : ''} ${className}`;

  if (empty) {
    return (
      <span className={cls} style={style} title={title} role={alt ? 'img' : undefined} aria-label={alt || undefined} onClick={onClick}>
        <Package size={Math.max(12, Math.round(size * 0.45))} aria-hidden="true" />
      </span>
    );
  }
  return (
    <img
      className={cls}
      style={style}
      src={proxy ? proxyImg(src) : src}
      alt={alt}
      title={title}
      loading="lazy"
      decoding="async"
      onError={() => setBroken(true)}
      onClick={onClick}
    />
  );
}
